/**
 * Mercado (spec 056): as cotacoes do dia (mini indice, mini dolar e o indice dolar de referencia) e o calendario
 * economico, pelos widgets do TradingView. O que mostrar (simbolos, paises e importancia) vem do backend; a tela so
 * desenha. Informativo: o aviso fica sempre na tela.
 */
import { Abas, Aviso, CabecalhoDePagina, EsqueletoDeCartao, Grade, Pilha, Secao, WidgetDoTradingView, mensagemDe, type ImportanciaDoEvento } from "@mtc/ui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useApi } from "../acoes";

type Mercado = {
  calendarios: { chave: string; rotulo: string; paises: string[]; importancia: ImportanciaDoEvento[] }[];
  cotacoes: { simbolo: string; rotulo: string; observacao: string }[];
};

export function PaginaMercado() {
  const { ler } = useApi();
  const q = useQuery({ queryKey: ["mercado"], queryFn: () => ler<Mercado>("/v1/me/mercado"), staleTime: Infinity });
  const [aba, setAba] = useState<string>();
  const cabecalho = <CabecalhoDePagina titulo="Mercado" descricao="As cotações do dia e o que sai na agenda econômica do Brasil e dos Estados Unidos." />;
  if (q.isLoading) return <Pilha espaco={5}>{cabecalho}<EsqueletoDeCartao linhas={2} rotulo="Abrindo o mercado" /></Pilha>;
  if (q.isError || !q.data) return <Pilha espaco={5}>{cabecalho}<Aviso tipo="erro">{mensagemDe(q.error, "Não deu pra abrir o mercado agora. Tente de novo em instantes.")}</Aviso></Pilha>;
  const d = q.data;
  const calendario = d.calendarios.find((c) => c.chave === aba) ?? d.calendarios[0];
  return (
    <Pilha espaco={6}>
      {cabecalho}
      <Aviso tipo="info">Informativo. Não é recomendação de investimento. Dados do TradingView, que podem atrasar.</Aviso>
      <Secao rotulo="Hoje" titulo="Cotações">
        <Grade minimo={240}>
          {d.cotacoes.map((c) => (
            <div key={c.simbolo} style={{ display: "grid", gap: "var(--e-1)" }}>
              <WidgetDoTradingView tipo="cotacao" simbolo={c.simbolo} rotulo={c.rotulo} />
              <span className="mtc-texto-2" style={{ fontSize: "var(--t-xs)" }}>{c.observacao}</span>
            </div>
          ))}
        </Grade>
      </Secao>
      {calendario && (
        <Secao rotulo="Agenda" titulo="Calendário econômico">
          {d.calendarios.length > 1 && <Abas rotulo="País do calendário" valor={calendario.chave} aoMudar={setAba} abas={d.calendarios.map((c) => ({ valor: c.chave, rotulo: c.rotulo }))} />}
          <WidgetDoTradingView key={calendario.chave} tipo="calendario" rotulo={`Calendário econômico: ${calendario.rotulo}`} paises={calendario.paises} importancia={calendario.importancia} />
        </Secao>
      )}
    </Pilha>
  );
}
